"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRouter = require("react-router");

var _breadcrumb = _interopRequireDefault(require("britive-design-system/core/components/breadcrumb"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.header-container {\n  background-color: #f4f4f4;\n  position: sticky;\n  top: 0;\n  width: 100%; }\n  .header-container .menu-container {\n    display: flex;\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem; }\n  .header-container .breadcrumb-wrapper {\n    margin-left: 3.5rem;\n    height: 1.1875rem;\n    display: inline; }\n  .header-container .page-title-container {\n    display: flex;\n    padding-left: 3.5rem;\n    padding-bottom: 1rem;\n    color: #393939; }\n    @media screen and (max-width: 768px) {\n      .header-container .page-title-container {\n        padding-left: 3.5rem;\n        padding-right: 3.5rem; } }\n  .header-container .title-with-no-breadcrumb {\n    padding-top: 0.5rem; }\n\n@media screen and (max-width: 768px) {\n  .typography-page-title {\n    font-size: 1rem; } }\n";
  var fileName = "compone_PageHeader";
  var element = document.querySelector("style[data-sass-component='compone_PageHeader']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var BreacrumbWithRouter = (0, _reactRouter.withRouter)(_breadcrumb.default);

var PageHeader = function PageHeader(_ref) {
  var _titleClass;

  var title = _ref.title,
      routeToNameList = _ref.routeToNameList;
  var showNavMenu = routeToNameList.length > 0;
  var titleClass = (_titleClass = {}, _defineProperty(_titleClass, _constants.classes.titleContainer, true), _defineProperty(_titleClass, _constants.classes.titleWithNoBreadcrumb, !showNavMenu), _titleClass);

  var getNavMenu = function getNavMenu() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.menuContainer
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "breadcrumb",
      role: _constants.breadcrumbRole,
      className: _constants.classes.breadcrumbWrapper
    }, /*#__PURE__*/_react.default.createElement(BreacrumbWithRouter, {
      routeToNameList: routeToNameList
    })));
  };

  var getPageTitle = function getPageTitle() {
    return /*#__PURE__*/_react.default.createElement("div", {
      role: _constants.pageTitleRole,
      "data-testid": "title",
      className: (0, _classnames.default)(_objectSpread({}, titleClass))
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "pageTitle"
    }, title));
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.headerContainer
  }, showNavMenu && getNavMenu(), getPageTitle()));
};

PageHeader.propTypes = {
  title: _propTypes.default.string.isRequired,
  routeToNameList: _propTypes.default.arrayOf(_propTypes.default.shape({
    route: _propTypes.default.string,
    name: _propTypes.default.string.isRequired
  }).isRequired)
};
var _default = PageHeader;
exports.default = _default;